export default __webpack_public_path__ + "static/media/login_logo.c11ee59d.png";